import styled from "@emotion/styled";

export const Container = styled.div`
    margin: 0 auto;
    padding: 0; 
`